import { render, staticRenderFns } from "./Secondary.vue?vue&type=template&id=c52e988a&scoped=true&"
import script from "./Secondary.vue?vue&type=script&lang=js&"
export * from "./Secondary.vue?vue&type=script&lang=js&"
import style0 from "./Secondary.vue?vue&type=style&index=0&id=c52e988a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52e988a",
  null
  
)

export default component.exports